import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20dark%20movie%20theater%20atmosphere%20with%20warm%20golden%20and%20crimson%20lighting%2C%20film%20reel%20and%20projector%20elements%2C%20dramatic%20shadow%20and%20light%20contrast%2C%20luxurious%20velvet%20texture%2C%20professional%20cinema%20photography%20style%2C%20rich%20dark%20tones%20with%20warm%20accent%20highlights&width=1800&height=1000&seq=hero-bg&orientation=landscape"
          alt="91精品影视 - 影视资源下载平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
                <i className="ri-fire-fill text-accent-500 text-sm"></i>
                <span className="text-accent-300 text-sm font-medium">2026暑期档 · 每日更新200+</span>
              </div>

              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-3">
                91精品影视
                <br />
                <span className="text-accent-400">海量高清资源下载平台</span>
              </h1>

              <p className="text-white/80 text-base md:text-lg font-medium mb-4">
                海量高清影视资源，随时随地离线观看
              </p>

              <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
                国内领先的影视资源下载服务平台，专注高清影视看片下载。平台汇聚超5万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类。每日更新最新资源，高速下载通道搭配专属安装包，稳定离线观看。
              </p>

              <div className="flex items-center justify-center lg:justify-start gap-6 mb-8">
                {siteInfo.stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">
                      {stat.value}
                    </div>
                    <div className="text-white/50 text-xs mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button
                  onClick={() => handleClick(siteInfo.primaryCta.href)}
                  className="w-full sm:w-auto px-8 py-3.5 rounded-md bg-accent-500 hover:bg-accent-600 text-foreground-950 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-download-line mr-2"></i>
                  {siteInfo.primaryCta.text}
                </button>
                <button
                  onClick={() => handleClick(siteInfo.secondaryCta.href)}
                  className="w-full sm:w-auto px-8 py-3.5 rounded-md border border-white/30 hover:border-white/60 hover:bg-white/10 text-white font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-compass-3-line mr-2"></i>
                  {siteInfo.secondaryCta.text}
                </button>
              </div>
            </div>

            <div className="flex-1 w-full max-w-lg lg:max-w-none">
              <div className="relative">
                <div className="rounded-lg overflow-hidden border border-white/10">
                  <img
                    src="https://readdy.ai/api/search-image?query=artistic%20film%20montage%20with%20golden%20cinematic%20lighting%2C%20multiple%20movie%20frames%20overlapping%2C%20film%20strip%20border%20design%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20dramatic%20composition%2C%20professional%20movie%20poster%20collage%20style%2C%20luxurious%20dark%20background&width=800&height=560&seq=hero-visual&orientation=landscape"
                    alt="91精品影视 - 影视资源合集展示"
                    className="w-full h-auto object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 w-full h-full rounded-lg border border-accent-500/30 -z-10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}